import { render, staticRenderFns } from "./newPlayerList.vue?vue&type=template&id=0a7c4266&scoped=true"
import script from "./newPlayerList.vue?vue&type=script&lang=js"
export * from "./newPlayerList.vue?vue&type=script&lang=js"
import style0 from "./newPlayerList.vue?vue&type=style&index=0&id=0a7c4266&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7c4266",
  null
  
)

export default component.exports